import React from 'react';
import { DollarSignIcon } from 'lucide-react';
export const TaxesRevenueWidget = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full" data-id="element-2134">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-2135">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-2136">
          <DollarSignIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-2137" />
          Taxes & Revenue
        </h2>
      </div>
      <div className="p-6" data-id="element-2138">
        <div className="mb-6" data-id="element-2139">
          <p className="text-xs text-gray-500" data-id="element-2140">Total Revenue (MTD)</p>
          <p className="text-2xl font-bold text-gray-900" data-id="element-2141">$1,248,350</p>
          <div className="flex items-center mt-1" data-id="element-2142">
            <span className="text-xs text-green-600 font-medium" data-id="element-2143">+8.2%</span>
            <span className="text-xs text-gray-500 ml-1" data-id="element-2144">from last month</span>
          </div>
        </div>
        <div className="space-y-4" data-id="element-2145">
          <div className="flex justify-between items-center" data-id="element-2146">
            <span className="text-sm text-gray-600" data-id="element-2147">Overdue Tax Bills</span>
            <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2148">
              42
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-2149">
            <span className="text-sm text-gray-600" data-id="element-2150">Pending Exemptions</span>
            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2151">
              17
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-2152">
            <span className="text-sm text-gray-600" data-id="element-2153">
              Payments Processed Today
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2154">
              64
            </span>
          </div>
        </div>
      </div>
      <div className="flex border-t border-gray-200 divide-x divide-gray-200" data-id="element-2155">
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2156">
          View Tax Dashboard
        </a>
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2157">
          Process Payments
        </a>
      </div>
    </div>;
};